// src/shared/hooks/useUserTheme.ts
import { useUser } from "src/business-types/grocery/components/UserContext";
import { colorOptions, fontOptions, borderHighlightOptions } from "src/shared/modules/profile/theme/themeConstants";

export const useUserTheme = () => {
  const { user } = useUser();

  const themeKey = user?.background_colour || "DodgerBlue";
  const bgClass = colorOptions[themeKey];
  const fontClass = fontOptions[user?.font_family || "Sans-serif"];
  const borderHighlight = borderHighlightOptions[themeKey] || "focus:ring-blue-500";

  return { themeKey, bgClass, fontClass, borderHighlight, colorClass: colorOptions[themeKey] || "" };
};
